module.exports = __webpack_public_path__ + "3ca1c909db6d88cab35deed80e6fede4.fbx";